export const public_data = {
    // baseURL: 'http://192.168.3.48:8085',
    baseURL: 'https://www.oriomics.com',
    async imageURL(e, limit) {
        try {
            // console.log(e,limit,'img')
            // 判断arr是否为数组类型
            let type = Object.prototype.toString.call(e)
            if (type == '[object Array]') {
                e.forEach(item => {
                    item.image = this.baseURL + item.image;
                    item.attachment = this.baseURL + item.attachment;
                    if (item.images && item.images.length > 2) {
                        item.images = JSON.parse(item.images);
                        item.count = item.images.length
                        item.imgShow=true
                        if (limit !== undefined) {
                            item.countPage = Math.ceil(item.count / limit)
                            item.imgs = item.images.slice(0, limit)
                        }
                        item.images.forEach((imgitme) => {
                            imgitme.image = this.baseURL + imgitme.image;
                        });
                    }
                });
            } else {
                // 为字符串类型
                e = this.baseURL + e
            }
            return Promise.resolve(e)
        } catch (err) {
            return Promise.reject(err)
        }

    }

}


// WEBPACK FOOTER //
// ./src/libs/public_data.js